module.exports = __webpack_public_path__ + "c38bdcedb55aed2f03f68223bfc5f3b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/arbeiten/R3.jpg
// module id = 345
// module chunks = 0